<template>
  <div id="friends">
    <h2>Friends</h2>
    <div class="content-data" style="overflow: auto" v-if="Array.isArray(limitFriends)">
      <b-table :fields="fields" :items="limitFriends" class="heroesPlayed-table">
        <template slot="player" slot-scope="data">
          <img :src="`${ data.item.avatar }`" >
          <span>{{ data.item.personaname }}</span>
          Last Played: {{ convertTime(data.item.last_played) }}
        </template>
        <template slot="matches" slot-scope="data">
          {{ data.item.games }}
        </template>
        <template slot="winrate" slot-scope="data">
          {{ winrate(data.item.games, data.item.win) }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Friends',
  props: {
    friends: Array
  },
  data () {
    return {
      fields: [
        { key: 'player', label: 'Player', thClass: 'header', tdClass: 'friends-data data' },
        { key: 'matches', label: 'Matches', thClass: 'header', tdClass: 'data' },
        { key: 'winrate', label: 'Win %', thClass: 'header', tdClass: 'data' }
      ]
    }
  },
  methods: {
    winrate (games, wins) {
      return ((wins / games) * 100).toFixed(2)
    },
    convertTime (lastPlayed) {
      let myDate = new Date(lastPlayed * 1000)

      /* 'Tue, 24 Sep 2019 12:04:29 GMT' */
      // myDate.toGMTString()

      /* '9/24/2019, 8:04:29 PM' */
      return myDate.toLocaleString().split(',')[0]
    }
  },
  computed: {
    limitFriends () {
      return this.friends !== null ? this.friends.slice(0, 8) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 520px) {
    img {
      display: block;
    }
  }
</style>
